export const base = 'gateway/main';
export const baseODATA = 'gateway/mainodata';

export const uploadFile = `${base}/FileImport`;
export const getDefaultColumns = `${base}/fileimportfields`;
export const getImportById = `${base}/fileimport`;
export const postCombineFields = `${base}/fileImporterDispatchMessage/sanitize`;
export const getQueryODATA = `${baseODATA}/fileimportsearchquery`;
export const deleteImport = `${base}/fileimport`;
